import { render, staticRenderFns } from "./BarcodeOrderItemTable.vue?vue&type=template&id=2827906d&scoped=true"
import script from "./BarcodeOrderItemTable.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderItemTable.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeOrderItemTable.vue?vue&type=style&index=0&id=2827906d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827906d",
  null
  
)

export default component.exports